import Axios from "axios";

export const SelectFacFrsCod = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/bCDVCLIs?typpe=FF&codep=&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "FF_COD", payload: response.data });
    });
  };
};
